import React, { useEffect, useState } from "react";
import CustomRoute from "./route";
import ErrorBoundary from "./errorBoundary";
import ContextContainer from "./Context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import InvalidTokenModal from "./Components/Model/SessionOut";
import { setAuthRef } from "./axios.config";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// const twentyFourHoursInMs = 1000 * 60 * 60 * 24;
// Created once at module level so App re-renders don't drop the cache.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // run even if the browser reports offline (otherwise queries stay "paused")
      networkMode: "always",
      refetchOnWindowFocus: false,
      // refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      // staleTime: twentyFourHoursInMs,
    },
    mutations: {
      networkMode: "always",
    },
  },
});

function App() {
  const clearEverything = () => {
    // setIsOpen(false);
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("token");
    localStorage.clear();
    window.location.href = "/";
  };

  const [isOpenInvalidTokenModal, setIsOpenInvalidTokenModal] = useState(false);
  const [isOpenInvalidTokenModalMessage, setIsOpenInvalidTokenModalMessage] =
    useState("");

  useEffect(() => {
    setAuthRef({
      isOpenInvalidTokenModal,
      setIsOpenInvalidTokenModal,
      isOpenInvalidTokenModalMessage,
      setIsOpenInvalidTokenModalMessage,
    });
  }, [isOpenInvalidTokenModal, isOpenInvalidTokenModalMessage]);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ContextContainer>
          <InvalidTokenModal
            open={isOpenInvalidTokenModal}
            Text={isOpenInvalidTokenModalMessage}
            onClose={() => {
              setIsOpenInvalidTokenModal(false);
              clearEverything();
            }}
          />
          <div className="max-w-[2000px] mx-auto ">
            <CustomRoute
              setIsOpenInvalidTokenModal={setIsOpenInvalidTokenModal}
            />
          </div>
        </ContextContainer>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
